import actions from './actions'
import mutations from './mutations'
import getters from './getters'
// import sampleResources from '@/sampleResources.json'

const namespaced = true

const state = {
    areas: null,
    loadingAreas: false,
    resources: null,
    searchResults: [],
    searchError: null,
    categories: ['Presentation & Triage', 'Assessment & Management', 'Discharge & Referral'],
    groups: ['Aetiology', 'Assessment Tools'],
    facets: [
        { name: 'area', options: [], order: 10 },
        { name: 'category', options: [], order: 20 },
        { name: 'group', options: [], order: 30 },
        { name: 'jurisdiction', options: [], order: 40 },
        { name: 'type', options: [], order: 50 }
    ],
    searchFilters: {},
    zipFiles: [],
    loadingResults: false,
    videoModalOpen: false,
    videoURL: null,
    editingResource: null,
    editingResourceData: null,
    lockTabs: false
}

export default {
    namespaced,
    state,
    actions,
    mutations,
    getters
}
